import { computed, defineComponent } from 'vue';
import classNames from '../_util/classNames';
import useConfigInject from '../config-provider/hooks/useConfigInject';
import { useCompactItemContext } from './Compact';
import useStyle from './style/addon';
export const spaceAddonProps = () => ({
    prefixCls: String,
});
const Addon = defineComponent({
    name: 'ASpaceAddon',
    inheritAttrs: false,
    props: spaceAddonProps(),
    setup(props, { attrs, slots }) {
        const { prefixCls, direction: directionConfig } = useConfigInject('space-addon', props);
        const [wrapSSR, hashId] = useStyle(prefixCls);
        const { compactItemClassnames, compactSize } = useCompactItemContext(prefixCls, directionConfig);
        const classes = computed(() => classNames(prefixCls.value, hashId.value, compactItemClassnames.value, {
            [`${prefixCls.value}-${compactSize.value}`]: compactSize.value,
        }, attrs.class));
        return () => {
            var _a;
            return wrapSSR(<div {...attrs} class={classes.value}>
          {(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}
        </div>);
        };
    },
});
export default Addon;
